<!--  -->
<template>
  <!-- <div>
    <div  v-for="(item, index) in businesslist" :key="index">
      <div style="height: 8vh; background-image: linear-gradient(#3f98eb, #006ed5);line-height: 8vh; color: #ffffff; text-align: center;font-size: 4.6vw;display: flex;">
       <div><img  @click="goBack()" style="width: 20px;height:20px;display:block;margin-top:4vw;margin-left:10px;" src="data:image/png;base64,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" alt=""> </div>
       <div style="margin-left:33vw;">{{item.processName}}</div>
     </div>
     <div>
      {{item.content}}
     </div>
      
   </div>
  </div> -->
    <div>
      <!-- 顶部 -->
    <div class="title_div">
      <img
        src="@/assets/icon_2/fanhui.png"
        style="height:20px;width:20px;margin-left:10px;"
        @click="goBack()"
      />
      <div> {{ choose_item.processName }}</div>
      <div style="width:40px;"></div>
    </div>
    <!--列表-->
    <div >
      <!-- <div style="font-size:18px;font-weight:800;margin:2vh 5vw;">
        {{ choose_item.title }}
      </div>
      <div style="text-align:right;margin-right:5vw;color:#A3A3A3;">
        {{ choose_item.author }}
      </div>
      <div
        style="text-align:right;margin-right:5vw;color:#A3A3A3;margin-top:5px;"
      >
        {{ choose_item.publishTime }}
      </div>
      <div style="display:flex;justify-content:center;margin-top:10px;">
        <img :src="choose_item.firstImgUrl" style="max-width:90vw;" />
      </div> -->
      <div class="zsy" style="font-size:14px;margin:2vh 5vw;display:flex;justify-content:center;" v-html="choose_item.content">
        
      </div>
      <!-- <div style="display:flex;justify-content:center;">
        <img :src="choose_item.img" style="max-width:90vw;" />
      </div>
      <div style="height:100px;"></div> -->
    </div>
  </div>
</template>

<script>

import qs from "qs";

export default {
  data() {
    return {
      businesslist:[],
      choose_item:{}
    };
  }, 
  mounted() {
    this.getNewsList(this.$route.params.id)
  },
  components: {},

  computed: {},

  methods: {
    getNewsList(id) {
      this.$axios
        .post(this.$api.getNewsList, qs.stringify({ processId: id }), {
          fromHeader: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        })
        .then((res) => {
          console.log(res,"kdlm")
          if(res.data.page.list){
             this.choose_item=res.data.page.list[0];
          }else{//如果没返回列表
              this.$message({
                  message: '暂无数据信息',
                  type:'warning'
              });
              setTimeout(()=>{
                this.goBack();
              },2000)
          }
          console.log( this.choose_item,"123")
        });
    },
     goBack() {
      this.$router.go(-1);
    }
    
  },
};
</script>
<style  scoped>
  
.title_div {
  height: 8vh;
  background-image: linear-gradient(#3f98eb, #006ed5);
  /* background: #3F98EB; */
  color: #ffffff;
  font-size: 4.6vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.every_option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e2e2;
  font-size: 14px;
  padding: 2vh 4vw;
}
.two_line {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

</style>
<style>
  .zsy img{
  width: 100%;
  height: 100%;
}

</style>